import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Task } from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';
import { TaskStatusApi } from 'api-typings/tasklist/tasklist';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-task-item',
  template: `
    <fl-bit
      flTrackingLabel="TaskEdit"
      class="TaskItemContainer"
      [class.Highlighted]="editingTaskId === task.id"
      (click)="clickedItemHandler()"
    >
      <fl-bit>
        <fl-checkbox
          [control]="checkboxControl.get('taskToggle')"
          (click)="$event.stopPropagation()"
          flTrackingLabel="TaskToggleStatus"
        ></fl-checkbox>
      </fl-bit>
      <fl-text class="TaskItemTitle"> {{ task?.title }} </fl-text>
    </fl-bit>
  `,
  styleUrls: ['./task-item.component.scss'],
})
export class TaskItemComponent implements OnInit {
  Margin = Margin;

  @Input() task: Task;
  @Input() editingTaskId: number | undefined;

  @Output() selected = new EventEmitter<Task>();
  @Output() itemToggled = new EventEmitter<Task>();

  checkboxSubscription?: Rx.Subscription;

  checkboxControl = new FormGroup({
    taskToggle: new FormControl(),
  });

  ngOnInit() {
    this.checkboxControl.controls.taskToggle.setValue(
      this.task.status !== TaskStatusApi.IN_PROGRESS,
    );
    this.checkboxSubscription = this.checkboxControl.valueChanges.subscribe(
      () => this.toggleCompletionHandler(),
    );
  }

  // Called when an item's completion is toggled.
  toggleCompletionHandler() {
    this.itemToggled.emit(this.task);
    // Unsubscribe before disabling the button to stop an infinite loop.
    if (this.checkboxSubscription) {
      this.checkboxSubscription.unsubscribe();
    }
    this.checkboxControl.controls.taskToggle.disable();
  }

  // Called when an item is clicked.
  clickedItemHandler() {
    this.selected.emit(this.task);
  }
}
